
/**
  ブランクページ（初期表示用）
*/
<template>
  <v-ons-page>
    <div class="content"></div>
  </v-ons-page>
</template>

<script>
export default {
  name: 'blank',
  data() {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/BlankPage.vue